import React from "react";

// Material-ui imports
import {
  Box,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";

// Third part libraries
import moment from "moment";
import OrderFilter from "./OrderFilter";
// Project imports
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
} from "../../../../components/CustomTable";
import { useDispatch } from "react-redux";
import TableLoader, { CustomPagination } from "../../../../components/CustomTable/CustomTable";
import distributor from "../../../../assets/images/distributor.svg";
import retailer from "../../../../assets/images/retailer.svg";
import salesman from "../../../../assets/images/salesman.svg";
import admin from "../../../../assets/images/admin.svg";
import system from "../../../../assets/images/system.svg";
import Loading from "../../../../assets/images/loading.svg";

type Order = "asc" | "desc";

interface HeadCell {
  disablePadding: boolean;
  id: any;
  label: string;
  numeric: boolean;
  isShow: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "Order ID",
    isShow: true,
  },
  {
    id: "placed_by",
    numeric: false,
    disablePadding: false,
    label: "Placed By",
    isShow: true,
  },
  {
    id: "lable",
    numeric: false,
    disablePadding: false,
    label: "",
    isShow: true,
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Items",
    isShow: true,
  },
  {
    id: "quantity",
    numeric: true,
    disablePadding: false,
    label: "Total Qty",
    isShow: true,
  },
  {
    id: "amount",
    numeric: true,
    disablePadding: false,
    label: "Total Amount",
    isShow: true,
  },
  {
    id: "order_date",
    numeric: false,
    disablePadding: false,
    label: "Order Date",
    isShow: true,
  },
];

const ReceivedTable = ({
  onFetchReceivedOrdersStart,
  onChangeApplyOrderFilter,
  onFetchTradersStart,
  orders: { receivedOrdersFilter, receivedOrders, loading, traders },
}) => {
  const [dense, setDense] = React.useState(false);
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<any>("id");
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [page, setPage] = React.useState(0);
  const [activePage, setActivePage] = React.useState<any>(1);

  const [noOfPages, setNoOfPages] = React.useState([]);

  const [rowsPerPage, setRowsPerPage] = React.useState(
    receivedOrdersFilter?.limit
  );
  
  const [showFullOrderItems, setShowFullOrderItems] = React.useState({});

  const isSelected = (id: any) => selected.indexOf(id) !== -1;

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = sortedData?.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  React.useEffect(() => {
    onFetchReceivedOrdersStart('asc', 'placed_by');
  }, []);

  const handleRequestSort = (field) => {
    const isAsc = orderBy === field && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(field);

    onFetchReceivedOrdersStart(isAsc ? "asc" : "desc", field);
  };
  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  };

  const sortedData = receivedOrders.orders ? receivedOrders.orders.sort(getComparator(order, orderBy)) : [];



  const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(
        selected?.slice(0, selectedIndex),
        selected?.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  React.useEffect(() => {
    const calculatePages = () => {
      const totalPages = Math.ceil(
        receivedOrders?.page_details?.total / receivedOrdersFilter?.limit
      );
      const newPages = [];
      for (let i = 1; i <= totalPages; i++) {
        newPages.push(i);
      }
      setNoOfPages(newPages);
      console.log("newPages", newPages);
    };

    calculatePages();
  }, [receivedOrders?.page_details?.total, receivedOrdersFilter?.limit]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - receivedOrders?.length)
      : 0;

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dispatch(
      onChangeApplyOrderFilter("limit", Number(event.target.value), "received")
    );
    onFetchReceivedOrdersStart('asc', 'placed_by');
  };

  const dispatch = useDispatch();

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeApplyOrderFilter("page", event.target.value, "received");
    setActivePage(Number(event.target.value));
    onFetchReceivedOrdersStart('asc', 'placed_by');
  };

  const handleSearchChange = (e) => {
    // dispatch(onChangeApplyOrderFilter("item_name", e, "received"));
    onChangeApplyOrderFilter("item_name", e, "received");
    onFetchReceivedOrdersStart('asc', 'placed_by');
  };

  const showNextPage = () => {
    onChangeApplyOrderFilter("page", activePage + 1, "received");
    setActivePage(activePage + 1);
    onFetchReceivedOrdersStart('asc', 'placed_by');
  };

  const showPrevPage = () => {
    onChangeApplyOrderFilter("page", activePage - 1, "received");
    setActivePage(activePage - 1);
    onFetchReceivedOrdersStart('asc', 'placed_by');
  };
  // Add a state variable to track whether to show the full list of order_items
  
  
  // Create a function to truncate order_items and show "..." when not showing the full list
  function truncateOrderItems(orderItems) {
    const maxItemsToShow = 2; // Change this number to show more or fewer items initially
    if (orderItems.length <= maxItemsToShow) {
      return orderItems.map((el) => el?.product?.name).join(",");
    } else {
      const truncatedItems = orderItems.slice(0, maxItemsToShow);
      return `${truncatedItems.map((el) => el?.product?.name).join(",")} ...`;
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2,}}>
        <EnhancedTableToolbar
          numSelected={selected?.length}
          handleChange={handleSearchChange}
          tableHeaderComps={
            <OrderFilter
              filterName="received"
              onChangeApplyOrderFilter={onChangeApplyOrderFilter}
              onFetchReceivedOrdersStart={onFetchReceivedOrdersStart}
              receivedOrdersFilter={receivedOrdersFilter}
              onFetchTradersStart={onFetchTradersStart}
              traders={traders}
            />
          }
        />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={(event, property) => handleRequestSort(property)}
              rowCount={sortedData?.length}
              headCells={headCells}
            />
            {/* {loading ? (
              <React.Fragment>
                {[...Array(10)].map((_, index) => (
                  <TableLoader rows={headCells} key={index} />
                ))}
              </React.Fragment>
            ) : ( */}
              <TableBody>
                {sortedData && sortedData?.length > 0 ? 
                  (sortedData?.map((row, index) => {
                    // console.log("/////",row.placed_by.f_name)
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const isFullOrderItemsShown = showFullOrderItems[row.id];
                    return (
                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, row.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                        sx={{ cursor: "pointer" }}
                      >
                        <TableCell padding="checkbox" sx = {{borderTop: "1px solid #ffffff00",
                          borderLeft: "1px solid #ffffff00", borderRight: "1px solid #ffffff00",}}>
                          <Checkbox
                            onClick={(event) => handleClick(event, row.id)}
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              "aria-labelledby": labelId,
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          {row?.id}
                        </TableCell>
                        <TableCell align="center" sx = {{borderTop: "1px solid #ffffff00",
                          borderLeft: "1px solid #ffffff00", borderRight: "1px solid #ffffff00",}}>
                          {row.placed_by
                            ? row?.placed_by.f_name
                              ? row?.placed_by.f_name
                              : "" + " " + row?.placed_by.l_name
                                ? row?.placed_by.l_name
                                : ""
                            : ""}
                        </TableCell>
                        <TableCell align="center">
                          {row?.placed_by?.role_details.name === "Sales" && (
                            <React.Fragment>
                              <img
                                src={salesman} // Use the imported image source
                                alt="salesman"
                                style={{ marginRight: "4px" }} // Add space using margin
                              />
                            </React.Fragment>
                          )}
                          {row?.placed_by?.role_details.name === "Distributor" && (
                            <React.Fragment>
                              <img
                                src={distributor} // Use the imported image source
                                alt="distributor"
                                style={{ marginRight: "4px" }} // Add space using margin
                              />
                            </React.Fragment>
                          )}
                          {row?.placed_by?.role_details.name === "Retailer" && (
                            <React.Fragment>
                              <img
                                src={retailer} // Use the imported image source
                                alt="retailer"
                                style={{ marginRight: "4px" }} // Add space using margin
                              />
                            </React.Fragment>
                          )}
                          {row?.placed_by?.role_details.name === "System" && (
                            <React.Fragment>
                              <img
                                src={system} // Use the imported image source
                                alt="system"
                                style={{ marginRight: "4px" }} // Add space using margin
                              />
                            </React.Fragment>
                          )}
                          {row?.placed_by?.role_details.name === "Admin" && (
                            <React.Fragment>
                              <img
                                src={admin} // Use the imported image source
                                alt="admin"
                                style={{ marginRight: "4px" }} // Add space using margin
                              />
                            </React.Fragment>
                          )}
                        </TableCell>
                        {/* <TableCell align="left">
                          {row?.order_items?.length > 0 &&
                            row?.order_items
                              ?.map((el) => el?.product?.name)
                              .join(",")}
                        </TableCell> */}
                        <TableCell align="left" sx = {{width: "440px"}}>
                          {isFullOrderItemsShown
                            ? row?.order_items?.map((el) => el?.product?.name).join(",")
                            : truncateOrderItems(row?.order_items)}
                          {row?.order_items.length > 2 && (
                            <span
                              style={{ cursor: "pointer", color: "blue" }}
                              // onClick={() => setShowFullOrderItems(!showFullOrderItems)}
                              onClick={(event) => {
                                event.stopPropagation();
                                setShowFullOrderItems(prevState => ({
                                  ...prevState,
                                  [row.id]: !prevState[row.id]
                                }));
                              }}
                            >
                              {isFullOrderItemsShown ? "Read Less" : "Read More"}
                            </span>
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {row?.order_items[0]?.quantity}
                        </TableCell>
                        <TableCell align="left">
                        ₹ {row?.order_value}
                        </TableCell>
                        <TableCell align="left">
                          {row?.order_date
                            ? moment(row?.order_date).format("YYYY-MM-DD")
                            : ""}
                        </TableCell>
                      </TableRow>
                    );
                  })) : 
                  (
                    <TableRow>
                      <TableCell colSpan={headCells.length} align="center">
                        <img src={Loading}/>
                        </TableCell>
                    </TableRow>
                  )
                }
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            {/* )} */}
          </Table>
        </TableContainer>
        <CustomPagination
          count={receivedOrders?.page_details?.total}
          rowsPerPage={rowsPerPage}
          page={activePage - 1}
          handleChangePage={() => { }}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handlePageChange={handlePageChange}
          pageNo={receivedOrdersFilter?.page}
          noOfPages={noOfPages}
          activePage={activePage}
          showPrevPage={showPrevPage}
          showNextPage={showNextPage}
        />
      </Paper>
    </Box>
  );
};

export default ReceivedTable;
